import { Link, useLocation } from 'react-router-dom';
import { Dropdown } from '../../../../components/Dropdown';

export function Menu({
  onClick,
  isMobileNavActive = false,
}: {
  onClick: () => void;
  isMobileNavActive?: boolean;
}) {
  const location = useLocation();
  const currentPath = location.pathname;

  const monitoramentoLinks = [
    {
      label: 'Estações meteorológicas',
      link: '/estacoes',
    },
    {
      label: 'Níveis dos rios e arroios',
      link: '/niveis-rios-arroios',
    },
    {
      label: 'Localização das chuvas',
      link: '/localizacao-chuvas',
    },
    {
      label: 'Perigo de deslizamentos',
      link: 'https://georisk.cemaden.gov.br/?lat=-29.6527945&lon=-50.5769391&municipio=4316006&grid=municipal',
    },
  ];

  const handleClick = () => {
    window.scrollTo(0, 0);
    if (isMobileNavActive) {
      onClick();
    }
  };

  return (
    <ul>
      <li>
        <Link
          to="/"
          className={currentPath === '/' ? 'item_active' : ''}
          onClick={handleClick}
        >
          Página inicial
        </Link>
      </li>

      {isMobileNavActive ? (
        monitoramentoLinks.map((item) => (
          <li key={item.label}>
            <Link
              to={item.link}
              className={currentPath === item.link ? 'item_active' : ''}
              onClick={handleClick}
            >
              {item.label}
            </Link>
          </li>
        ))
      ) : (
        <li>
          <Dropdown
            title="Monitoramento"
            items={monitoramentoLinks}
            currentPath={currentPath}
          />
        </li>
      )}

      <li>
        <Link
          to="/outras-informacoes"
          className={currentPath === '/outras-informacoes' ? 'item_active' : ''}
          onClick={handleClick}
        >
          Outras informações
        </Link>
      </li>

      <li>
        <Link
          to="/contato"
          className={currentPath === '/contato' ? 'item_active' : ''}
          onClick={handleClick}
        >
          Contato
        </Link>
      </li>
    </ul>
  );
}
